import FractionsLogo from '~/assets/drill/fractions'
import DrillTopicListElement from '~/components/Drill/DrillTopicsList/components/DrillTopicListElement'

export default function Fractions({
  title,
  completed,
  path,
}: {
  title: string
  completed: boolean
  path: string
}): React.ReactElement {
  const gridMobile = 'row-start-3 row-end-5 col-start-2 col-end-4'
  const gridTablet = 'md:row-start-1 md:row-end-1 md:col-start-3 md:col-end-5'
  const gridDesktop = 'xl:row-start-1 xl:row-end-1 xl:col-start-3 xl:col-end-5'
  const gridClassNames = [gridMobile, gridTablet, gridDesktop].join(' ')

  return (
    <DrillTopicListElement
      completed={completed}
      gridClassNames={gridClassNames}
      image={FractionsLogo}
      imageClassNames="h-18"
      path={path}
      title={title}
    />
  )
}
